import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import {
  Form,
  List,
  Card,
  Button,
  Radio,
  Checkbox,
  Spin,
  notification,
  Modal,
} from 'antd';
import _ from 'lodash';
import $ from 'jquery';
import {
  SearchOutlined,
  CopyOutlined,
  FormOutlined,
  ShopOutlined,
} from '@ant-design/icons';
import './styles.module.scss';
import AppHelper from 'libs/AppHelper';
import { API_HOST } from '../../configs/env';
import whttp from '../../libs/whttp';
import { genFormItemAtrribute } from 'libs/FormHelper';
import { RadioControl, CheckboxControl } from '@wordpress/components';
import { withState } from '@wordpress/compose';
import bannerImage from 'assets/img/banner/banner-catalog.png';
import { store } from '../../reducers';
import { updateAuthInfo } from '../../reducers/auth';
import { __ } from '@wordpress/i18n';

const VC_CONFIG = _.get(window, 'VC_CONFIG', {});
const defaultListInfo = {
  current: 1, //目前頁數
  page_size: 10, //一頁幾筆
  total: 1, //以此query條件，總共幾筆資料
  rows: [],
};
// 前端頁面
export default class UserLoginOca extends Component {
  state = {
    listInfo: _.cloneDeep(defaultListInfo),
    To: null,
    ContactData: {},
  };
  getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }
  componentDidMount() {
    var To = AppHelper.getLocalStorage('to-href');
    const ContactData = AppHelper.getLocalStorage('contact-data');

    if (To) {
      this.setState({ To: To }, () => {
        AppHelper.removeLocalStorage('to-href');
      });
      if (ContactData)
        this.setState({ ContactData: ContactData }, () => {
          this.exchangeToken(this.getParameterByName('code'));
          AppHelper.removeLocalStorage('contact-data');
        });
      console.log('sso', To, ContactData);
    }
    let code = this.getParameterByName('code');
    console.log('code:', code);

    if (
      this.getParameterByName('src_token') &&
      this.getParameterByName('src_client_id')
    ) {
      return this.subLogin(
        this.getParameterByName('src_token'),
        this.getParameterByName('src_client_id')
      );
    }

    if (this.getParameterByName('redirectFlag')) {
      return this.thirdBinding(this.getParameterByName('redirectFlag'));
    }
    if (!_.isEmpty(code)) {
      return this.exchangeToken(code);
    }
    // 判斷是否有user

    const authorization = _.get(this.props, 'auth.authorization');

    if (!_.isEmpty(authorization)) {
      return this.fetchUserInfo();
    }

    window.location.href = '/';
  }

  exchangeToken = (code) => {
    this.props.cleanAuthInfo();
    console.log('exchangecode', code);
    if (code == null) {
      // return notification['error']({
      //   message: __('登入失敗，請稍候再試','cec-plugin-stores'),
      //   onClose:() => {
      //     window.location.href = VC_CONFIG.INDEX_URL;
      //   }
      // });

      return Modal.error({
        title: __('登入失敗，請稍候再試。', 'cec-plugin-stores'),
        onOk: () => {
          window.location.href = VC_CONFIG.INDEX_URL;
        },
      });
    }
    whttp.get(
      API_HOST + `/api/account/getAccessTokenOca?code=${code}`,
      {},
      (state, res) => {
        console.log(state, res);
        this.setState({ isSubmitData: false });

        const {
          code = 100,
          reason = __('發生錯誤', 'cec-plugin-stores'),
          data = {},
        } = res;

        if (state === false) {
          // return notification['error']({
          //           message: __('登入失敗，請稍候再試。','cec-plugin-stores'),
          //           description: reason,
          //           onClose:() => {
          //             //window.location.href = VC_CONFIG.INDEX_URL;
          //           }
          //         });
          return Modal.error({
            title: '登入失敗，請稍候再試。',
            content: reason,
          });
        }

        if (code !== 200) {
          if (code == 901) {
            //進行手機綁定流程，根據回傳的uri轉導到該頁面(回傳格式在下方)。由OCA UI進行資料異動
            // return notification['warning']({
            //   message: __('須將帳號改為手機', 'cec-plugin-stores'),
            //   description: reason,
            //   onClose: () => {
            //     window.location.href = data.uri;
            //   }
            // });

            return Modal.warning({
              title: __('須將帳號改為手機', 'cec-plugin-stores'),
              content: reason,
              onOk: () => {
                window.location.href = data.uri;
              },
            });
          } else if (code == 902) {
            //調用OCA帳號更新UI，根據回傳的uri轉導到該頁面(回傳格式在下方)。由OCA UI進行資料異動
            // return notification['warning']({
            //   message: __('更新帳號資訊。', 'cec-plugin-stores'),
            //   description: reason,
            //   onClose: () => {
            //     window.location.href = data.uri;
            //   }
            // });

            return Modal.warning({
              title: __('更新帳號資訊。', 'cec-plugin-stores'),
              content: reason,
              onOk: () => {
                window.location.href = data.uri;
              },
            });
          } else if (code == 903) {
            //調用OCA帳號更新UI，根據回傳的uri轉導到該頁面(回傳格式在下方)。由OCA UI進行資料異動
            // return notification['warning']({
            //   message: __('進行解除綁定後補資料流程', 'cec-plugin-stores'),
            //   description: reason,
            //   onClose: () => {
            //     window.location.href = data.uri;
            //   }
            // });

            return Modal.warning({
              title: __('進行解除綁定後補資料流程', 'cec-plugin-stores'),
              content: reason,
              onOk: () => {
                window.location.href = data.uri;
              },
            });
          } else if (code == 999) {
            //顯示錯誤訊息並返回首頁
            // return notification['error']({
            //   message: __('解除綁定不完全，請與客服中心聯繫。', 'cec-plugin-stores'),
            //   description: reason,
            //   onClose: () => {
            //     window.location.href = VC_CONFIG.INDEX_URL;
            //   }
            // });

            return Modal.error({
              title: __(
                '解除綁定不完全，請與客服中心聯繫。',
                'cec-plugin-stores'
              ),
              content: reason,
              onOk: () => {
                window.location.href = VC_CONFIG.INDEX_URL;
              },
            });
          }

          // return notification['error']({
          //   message: '提示',
          //   description: reason,
          //   onClose: () => {
          //     window.location.href = VC_CONFIG.INDEX_URL;
          //   }
          // });

          return Modal.error({
            title: '提示',
            content: reason,
            onOk: () => {
              window.location.href = VC_CONFIG.INDEX_URL;
            },
          });
        }

        this.props.updateAuthInfo({ authorization: data.token });
        console.log('exchangeToken', data.token);
        this.fetchUserInfo();
      }
    );
  };
  fetchUserInfo = () => {
    AppHelper.updateUserInfo((resp) => {
      console.log('updateUserInfo userInfo:', resp);

      var link = VC_CONFIG.INDEX_URL;
      notification['success']({
        message: __('登入成功', 'cec-plugin-stores'),
        duration: 1,
        onClose: () => {
          if (this.state.To) {
            link = link + this.state.To;
            if (this.state.ContactData) {
              link =
                link +
                '?data=' +
                encodeURIComponent(JSON.stringify(this.state.ContactData));
            }
          } else {
            link = VC_CONFIG.INDEX_URL + '/profile';
          }

          console.log('sso網頁轉至: ', link);

          window.location.replace(link);
        },
      });
    });
  };
  //測試： https://www.uni-prosperity.com.tw/sso?src_token=123&src_client_id=123
  subLogin = (src_token, src_client_id) => {
    this.props.cleanAuthInfo();

    if (src_token == null || src_client_id == null) {
      // return notification['error']({
      //   message: __('登入失敗，請稍候再試','cec-plugin-stores'),
      //   onClose:() => {
      //     window.location.href = VC_CONFIG.INDEX_URL;
      //   }
      // });

      return Modal.error({
        title: __('登入失敗，請稍候再試。', 'cec-plugin-stores'),
        onOk: () => {
          window.location.href = VC_CONFIG.INDEX_URL;
        },
      });
    }

    this.setState({ isSubmitData: true });
    whttp.get(
      API_HOST + `/api/account/getSubLogInOca`,
      {
        src_token: src_token,
        src_client_id: src_client_id,
      },
      (state, res) => {
        this.setState({ isSubmitData: false });

        const {
          code = 100,
          reason = __('發生錯誤', 'cec-plugin-stores'),
          data = {},
        } = res;

        if (state === false) {
          // return notification['error']({
          //   message: __('登入失敗，請稍候再試。','cec-plugin-stores'),
          //   description: reason,
          //   onClose:() => {
          //     //window.location.href = VC_CONFIG.INDEX_URL;
          //   }
          // });

          return Modal.error({
            title: __('登入失敗，請稍候再試。', 'cec-plugin-stores'),
            content: reason,
            onOk: () => {
              // window.location.href = VC_CONFIG.INDEX_URL;
            },
          });
        }
        if (code == 300) {
          //顯示錯誤訊息並返回首頁
          // return notification['error']({
          //         message: __('登入失敗，請稍候再試。','cec-plugin-stores'),
          //         description: reason,
          //         onClose:() => {
          //           window.location.href = VC_CONFIG.INDEX_URL;
          //         }
          //       });
          return Modal.error({
            title: __('登入失敗，請稍候再試。', 'cec-plugin-stores'),
            content: reason,
            onOk: () => {
              window.location.href = VC_CONFIG.INDEX_URL;
            },
          });
        } else if (code !== 200 && code !== 300) {
          // return notification['error']({
          //   message: __('登入失敗，請稍候再試。','cec-plugin-stores'),
          //   description: reason,
          //   onClose:() => {
          //     //window.location.href = VC_CONFIG.INDEX_URL;
          //   }
          // });
          return Modal.error({
            title: __('登入失敗，請稍候再試。', 'cec-plugin-stores'),
            content: reason,
            onOk: () => {
              // window.location.href = VC_CONFIG.INDEX_URL;
            },
          });
        }

        if (code == 200) {
          this.props.updateAuthInfo({ authorization: data.token });
          console.log('subLogin', data, data.token);
          AppHelper.updateUserInfo(() => {
            var link = VC_CONFIG.INDEX_URL;
            notification['success']({
              message: __('登入成功', 'cec-plugin-stores'),
              duration: 1,
              onClose: () => {
                if (this.state.To) {
                  link = link + this.state.To;
                  if (this.state.ContactData) {
                    link =
                      link +
                      '?data=' +
                      encodeURIComponent(
                        JSON.stringify(this.state.ContactData)
                      );
                  }
                } else {
                  link = VC_CONFIG.INDEX_URL + '/profile';
                }
                console.log('sso網頁轉至: ', link);
                window.location.href = link;
              },
            });
          });
        }
      }
    );
  };

  Logout = () => {
    notification['warning']({
      message: __('已成功登出', 'cec-plugin-stores'),
      duration: 1,
      onClose: () => {
        //AppHelper.removeLocalStorage('contact-data')
        //AppHelper.removeLocalStorage('to-href')
        //this.props.cleanUserInfo();
        //this.props.cleanAuthInfo();
        window.location.href = VC_CONFIG.INDEX_URL;
      },
    });
  };

  //第三方綁定
  thirdBinding = (redirectFlag) => {
    var showMessage = '您已完成綁定第三方帳號';
    switch (redirectFlag) {
      case '1':
        showMessage = '您已完成綁定第三方帳號(Facebook)關聯';
        break;
      case '2':
        showMessage = '您已完成解除第三方帳號(Facebook)關聯';
        break;
      case '3':
        showMessage = '您已完成綁定第三方帳號(G+)關聯';
        break;
      case '4':
        showMessage = '您已完成解除第三方帳號(G+)關聯';
        break;
      case '5':
        showMessage = '您已完成綁定第三方帳號(Line)關聯';
        break;
      case '6':
        showMessage = '您已完成解除第三方帳號(Line)關聯';
        break;
      default:
        return;
    }
    // return notification['success']({
    //   message: __(showMessage,'cec-plugin-stores'),
    //   duration: 3,
    //   onClose:() => {
    //     window.location.href = VC_CONFIG.INDEX_URL+"/profile";
    //   }
    // });

    return Modal.success({
      title: __(showMessage, 'cec-plugin-stores'),
      onOk: () => {
        window.location.href = VC_CONFIG.INDEX_URL + '/profile';
      },
    });
  };

  render() {
    return (
      <div
        style={{ height: '350px' }}
        className='jumbotron d-flex align-items-center'
      >
        <div className='text-center'>
          <Spin
            className='mt-4'
            size='large'
            tip={__('登入中...', 'cec-plugin-stores')}
          />
        </div>
      </div>
    );
  }
}

// 編輯器
export class UserLoginOcaEditor extends Component {
  formRef = React.createRef();
  state = {
    listInfo: _.cloneDeep(defaultListInfo),
  };
  componentDidMount() {
    AppHelper.updateConfig();
    console.log('kkk', this.props.attributes);

    this.formRef.current.setFieldsValue(this.props.attributes);
  }
  render() {
    const listInfo = this.state.listInfo;
    const options = _.get(this, 'props.app.options', {});
    console.log('editor', this.props);

    return (
      <div className='vu-blocks-editor'>
        <h2>會員 SSO 登入模組</h2>
        <Form ref={this.formRef} name='basic' className='basicForm' />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/blocks/users/user-sso-login-oca.js